// Module
var code = "<title>Email Confirmation</title> <div ng-cloak class=\"h100\"> <vue-component name=\"EmailConfirmation\" class=\"h100\"/> </div> ";
// Exports
module.exports = code;